exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.push([module.id, "@import url(https://use.typekit.net/srv0wme.css);", ""]);

// module
exports.push([module.id, "/*\r\n$breakpoint argument choices:\r\n- xs\r\n- sm\r\n- md\r\n- lg\r\n- xl\r\n*/\n.pgTitle[data-v-1a1d373c] {\n  text-align: center;\n  font-size: 2.875rem;\n  margin: 10px 0 20px 0;\n}\n@media (max-width: 1200px) {\n.pgTitle[data-v-1a1d373c] {\n      font-size: calc(1.075rem + 2.4vw) ;\n}\n}\n.search[data-v-1a1d373c] {\n  max-width: 1100px;\n  margin: 0 auto;\n}\n", ""]);

// exports
